<!--
 * @Description: 修改密码验证手机号
 * @Date: 2021-11-10 13:44:01
-->
<template>
  <div class="user-login__item user-login__forget">
    <div class="user-login__sec">验证手机号</div>
    <LoginForm
      ref="formRef"
      :formData="formData"
      :itemList="itemList"
      :pageType="LoginTypeEnum.FORGET"
    ></LoginForm>
    <div class="user-login__forget-foot">
      <base-button @click="onCancel" type="default">取消</base-button>
      <base-button :click="onLogin">下一步</base-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, defineModel } from 'vue';
import { BaseButton } from 'xrk-components';

import type { FormRef, FormData } from '../types/index';
import { LoginForm } from './login-base/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { phoneLogin } from '../data-source/apis';

import { useSetup } from '../store';

const store = useSetup();
const model = defineModel();
const itemList = ref<any[]>([FormItemEnum.phone]);
const forgetThePassword = 1;
// 表单实例
const formRef = ref<FormRef>(null);
const formData = ref<FormData>({
  [FormItemEnum.phone]: store.loginData.phone2
});

const onCancel = () => {
  model.value = 'login-main';
};

const onLogin = async () => {
  await formRef.value.validate();
  const { data } = await phoneLogin({
    [FormItemEnum.phone]: formRef.value.data[FormItemEnum.phone],
    [FormItemEnum.code]: formRef.value.data[FormItemEnum.code],
    forgetThePassword
  });
  // 仅同步信息
  store.setInfo(data);
  store.setLoginData({ phone2: formRef.value.data[FormItemEnum.phone] });
  model.value = 'login-reset';
};
</script>

<style lang="scss" scoped>
.user-login__forget {
  .user-login__forget-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      width: 167px;
      height: 44px;
    }
  }
}
</style>
